import type { ReactNode } from 'react';

import DisplayOn from './DisplayOn';

type Props = {
  children: ReactNode;
};

const DisplayUpLg = ({ children }: Props) => (
  <DisplayOn mode="up" defaultState={true}>
    {children}
  </DisplayOn>
);

DisplayUpLg.displayName = 'DisplayUpLg';

export default DisplayUpLg;
